import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from '@mui/material'
import useInnovaTheme from './hooks/useInnovaTheme'
import { Icon as Iconify } from '@iconify/react'

const ConfirmModal = ({ open, onClose, title, text, buttons }) => {
  const { getTextColor } = useInnovaTheme()
  
  return (
    <Dialog
      PaperProps={{
        sx: {
          backgroundColor: 'itemBackground',
        },
      }}
      open={open}
      onClose={onClose}>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pr: 1,
        }}>
        {title}

        <IconButton
          onClick={onClose}
          size='small'
          sx={{
            color: getTextColor(),
          }}>
          <Iconify icon='mdi:close' />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ color: getTextColor() }}>{text}</DialogContent>
      <DialogActions>
        {buttons &&
          buttons.map((button, index) => (
            <Button
              key={index}
              variant={button.variant}
              disabled={button.disabled}
              onClick={() => {
                onClose()
                button.onClick()
              }}
              color={button.color}
              startIcon={button.icon}>
              {button.label}
            </Button>
          ))}
      </DialogActions>
    </Dialog>
  )
}
export default ConfirmModal
